export default __webpack_public_path__ + "static/media/app-service_3.1ea9e182.png";